import { render, staticRenderFns } from "./component.vue?vue&type=template&id=80a41fd8&scoped=true&"
import script from "./component.vue?vue&type=script&lang=js&"
export * from "./component.vue?vue&type=script&lang=js&"
import style0 from "./component.vue?vue&type=style&index=0&id=80a41fd8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80a41fd8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/merchant_5Yxh/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('80a41fd8')) {
      api.createRecord('80a41fd8', component.options)
    } else {
      api.reload('80a41fd8', component.options)
    }
    module.hot.accept("./component.vue?vue&type=template&id=80a41fd8&scoped=true&", function () {
      api.rerender('80a41fd8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/decoration/modules/auction_album/component.vue"
export default component.exports